import { useRuntimeConfig } from '#imports'

import type { Market } from '@backmarket/http-api'
import type { RouteRecordRaw } from 'vue-router'

import { ROUTES as AUTH_ROUTES } from '../auth/routes'

export const DASHBOARD = {
  SELF: 'dashboard',
  FAVORITES: 'favorites',
  MY_ORDERS: {
    CANCEL: 'cancel',
    SELF: 'orders',
    WITHDRAW: {
      INSURANCES: 'withdraw_insurances',
      ORDER: 'withdraw_order',
    },
  },
  MY_PETANQUE_ORDERS: 'petanque_orders',
  MY_SALES: 'my_sales',
  KYC: {
    OTHER: 'dashboard_other',
    PROFILE: 'profile',
    REFER_FRIEND: 'refer_friend',
  },
}

export default ({ market }: { market: Market }): RouteRecordRaw[] => {
  const { FF_ENABLED_COUNTRIES_FRONT_APPS_ROUTE_MY_ORDERS } =
    useRuntimeConfig().public

  const isMyOrdersFSMEnabled = (
    FF_ENABLED_COUNTRIES_FRONT_APPS_ROUTE_MY_ORDERS as string
  )?.includes(market.countryCode)

  return [
    {
      path: '/:locale/dashboard',
      name: DASHBOARD.SELF,
      redirect: { name: DASHBOARD.MY_ORDERS.SELF },
      component: () => import('./layout/DashboardLayout.vue'),
      children: [
        {
          path: 'profile',
          name: DASHBOARD.KYC.PROFILE,
          component: () => null,
          meta: { disableClientSideNavigation: () => true },
        },
        {
          path: 'favorites',
          name: DASHBOARD.FAVORITES,
          component: () => null,
          meta: { disableClientSideNavigation: () => true },
        },
        {
          path: 'others',
          component: () => null,
          name: DASHBOARD.KYC.OTHER,
          meta: { disableClientSideNavigation: () => true },
        },
        {
          path: 'orders',
          name: DASHBOARD.MY_ORDERS.SELF,
          component: () => import('./my-orders/MyOrders.vue'),
          meta: {
            disableClientSideNavigation: () => !isMyOrdersFSMEnabled,
          },
        },
        {
          path: 'orders/:orderId/orderlines/:orderlineId/cancel',
          component: () => null,
          name: DASHBOARD.MY_ORDERS.CANCEL,
          meta: { disableClientSideNavigation: () => true },
        },
        {
          path: 'orders/:orderId/orderlines/:orderlineId/withdraw',
          component: () => null,
          name: DASHBOARD.MY_ORDERS.WITHDRAW.ORDER,
          meta: { disableClientSideNavigation: () => true },
        },
        {
          path: 'orders/:orderId/orderlines/:orderlineId/insurances/withdraw',
          component: () => null,
          name: DASHBOARD.MY_ORDERS.WITHDRAW.INSURANCES,
          meta: { disableClientSideNavigation: () => true },
        },
        {
          path: 'past-orders',
          component: () => null,
          name: DASHBOARD.MY_PETANQUE_ORDERS,
          meta: { disableClientSideNavigation: () => true },
        },
        {
          path: 'refer-friend',
          component: () => null,
          name: DASHBOARD.KYC.REFER_FRIEND,
          meta: { disableClientSideNavigation: () => true },
        },
        {
          path: 'sales',
          component: () => null,
          name: DASHBOARD.MY_SALES,
          meta: { disableClientSideNavigation: () => true },
        },
      ],
      meta: {
        auth: {
          required: true,
          // TODO: [FRONT-1199] remove this after global config change
          redirection: { name: AUTH_ROUTES.AUTH.LOGIN },
        },
        disableClientSideNavigation: () => !isMyOrdersFSMEnabled,
      },
    },
  ]
}
